import React, { useEffect, useRef, useState } from 'react';
import {
  Modal,
  Button,
  QuantaFormik,
  useResponsiveParams,
  MixedGridGroup,
  useQuantaFormikContext,
  QuantaDateInput,
  Grid,
  GridItem,
  Text,
  QuantaSelect,
  Label,
} from 'quanta-ui';
import moment from 'moment';
import {
  // GET_PCV_POLICY_VAR_DETAILS,
  GET_MISCD_POLICY_VAR_DETAILS,
  MODEL_DETAILS,
  RTO_LIST_BRAND_LIST_YEAR_RANGE,
  VARIANT_DETAILS,
  // GET_CARRIAGE_PCV,
  GET_CARRIAGE_MISCD,
  // GET_PERMIT_PCV,
  GET_PERMIT_MISCD,
  GET_VEHICLEUSE_MISCD,
  GET_SUBPRODUCT_MISCD,
  GET_TYPEVEHICLE_MISCD,
  GET_RTO_DETAILS
} from '../../queries';
import {Loading} from 'quanta-flows/modules/layout';
import {Error} from 'quanta-flows/modules/layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationCircle,
  faSave,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
//import useFetchCacheQuery from './lib/graphql/useFetchCacheQuery';
import { useFetchCacheQuery } from 'quanta-flows';
import { useQuery } from '@apollo/client';

export default function VehicleDataModal({
  setShowVehicleDetailsModal,
  showVehicleDetailsModal,
  setVehicleDetailValues,
  vehicleDtls,
  vehicleRegNo,
  engineNo,
  chasisNo,
  businessType,
  productCode,
  productName,
  lobCode,
  lobName,
  quoteNumber,
  modify,
  setParentFieldValue,
  vehicleTypeList,
  setVehicleTypeList,
  pastPolicyExpiryDate,
  anyPreviousPolicyforVehicleTaken,
  productVariant,
}) {
  const [initLoad, setInitLoad] = useState(false);
  const [motorQuote, setMotorQuote] = useState(null);
  const initLoadRef = useRef([]);
  const {
    loading: loadingBuyPolicy,
    error: errorBuyPolicy,
    data: dataBuyPolicy,
    previousData,
  } = useQuery(  GET_MISCD_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: new Set(initLoadRef?.current).size >= 1 ? true : false,
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 1];
    },
  });
  if (loadingBuyPolicy) {
    return (
      <div className="min-h-screen">
        <Loading customMessage={'Fetching Vehicle Details'} />
      </div>
    );
  }
  if (errorBuyPolicy) {
    return (
      <div className="min-h-screen">
        <Error error={errorBuyPolicy} />
      </div>
    );
  }
  const { buyMotorPolicy } = dataBuyPolicy
    ? dataBuyPolicy
    : previousData;
  const [rtoList, setRtoList] = useState(  // vehicleDtls?.rtoList
  //   && vehicleDtls?.rtoList?.length > 0
  //   ? vehicleDtls?.rtoList
  //   : []
  //Added
  vehicleDtls?.current?.rtoList
    && vehicleDtls?.current?.rtoList?.length > 0
      ? vehicleDtls?.current?.rtoList 
      : []
  );
//Added
// const [makeList, setMakeList] = useState([]);
//Added
const [makeList, setMakeList] = useState(
  vehicleDtls?.current?.makeList &&
    vehicleDtls?.current?.makeList?.length > 0
    ? vehicleDtls?.current?.makeList
    : []
);
  const [yearRange, setYearRange] = useState([]);
  const [loadingRtoDetails, setLoadingRtoDetails] = useState(false);
  const [errorRtoDetails, setRtoError] = useState(null);
  const vehicleModalRef = useRef();
  const fetchQuery = useFetchCacheQuery();
  // const { values, setFieldValue } = useQuantaFormikContext();
  let repeatForMobile = 1;
  let repeatForDesktop = 3;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });


  useEffect(() => {
    const getRtoDetails = async () => {
      try {
        const getPCVPolicyVarDetailsQuery = fetchQuery({
          query: GET_MISCD_POLICY_VAR_DETAILS,
        });
        setLoadingRtoDetails(true);
        const { data: dataPCVPolicyVarDetails } =
          await getPCVPolicyVarDetailsQuery;
        setMotorQuote(dataPCVPolicyVarDetails?.motorQuote);
        const rtoBrandYearQuery = fetchQuery({
          query: RTO_LIST_BRAND_LIST_YEAR_RANGE,
          variables: {
            // filterRTOList: {
            //   rtoLocationCode: motorQuote?.rtoLocationCode
            //     ? motorQuote?.rtoLocationCode
            //     : '',
            //   rtoLocationDesc: motorQuote?.rtoLocationDesc
            //     ? motorQuote?.rtoLocationDesc
            //     : '',
            //   imdCode:
            //     dataPCVPolicyVarDetails?.selectedIntermediary
            //       ?.intermediaryCode ||
            //     dataPCVPolicyVarDetails?.motorQuote
            //       ?.intermediaryDetails?.code,
            //       productCode: productCode,
            // },
            filterMakeList: { productCode: productCode },
            type: 'Year of Manufacture',
          },
        });
        const { data } = await rtoBrandYearQuery;
        setLoadingRtoDetails(false);
        // setRtoList(data?.rtoList);
        setMakeList(data?.makeList);
           //Added
           vehicleDtls.current = {
            ...vehicleDtls.current,
            makeList: data?.makeList,
          }
          //Added
        setYearRange(data?.yearRange);
      } catch (error) {
        setLoadingRtoDetails(false);
        setRtoError(error?.message);
      }
    };
    if (showVehicleDetailsModal && !initLoad) {
      setInitLoad(true);
      getRtoDetails();
    }
  }, [showVehicleDetailsModal]);
  const { loading: loadingvehicleuseType,
    error: errorvehicleuseType,
    data: datavehicleuseType, 
  } = useQuery(GET_VEHICLEUSE_MISCD, {
      fetchPolicy: 'cache-and-network',
      variables: {
        input: {
          productCode: "All",
          domainType: 'Vehicle UseMISCD',
        },
      },
      onCompleted: (data) =>  {
      },
    });


    const { loading: loadingSubProductType,
      error: errorSubProductType,
      data: dataSubProductType, 
    } = useQuery(GET_SUBPRODUCT_MISCD, {
        fetchPolicy: 'cache-and-network',
        variables: {
          input: {
            productCode: "All",
            domainType: 'SubProductMISCD',
          },
        },
        onCompleted: (data) =>  {
        },
      });
      const {
    loading: loadingTypeOfMiscVehicleType,
    error: errorTypeOfMiscVehicleType,
    data: dataTypeOfMiscVehicleType,
  } = useQuery(GET_TYPEVEHICLE_MISCD, {
    fetchPolicy: 'network-only',
    variables: {
      input: {
        productCode: productCode,
        // domainType: 'TypeOfMiscVehicleMISCD',
      },
    },
    onCompleted: (data) => {},
  });
    
  

  const { loading: loadingCarriageType,
    error: errorCarriageType,
    data: dataCarriageType, } = useQuery(GET_CARRIAGE_MISCD, {
      fetchPolicy: 'cache-and-network',
      variables: {
        input: {
          productCode: "All",
          domainType: 'Carriage Type MISCD',
        },
      },
      onCompleted: (data) =>  {
// console.log("values",values)
//         if (dataCarriageType !=='') {
//           setFieldValue(
//             `carriageType.value`,'Public'
//           );
//         }
      },
    });
  // const {
  //   loading: loadingPermitType,
  //   error: errorPermitType,
  //   data: dataPermitType,
  // } = useQuery(GET_PERMIT_MISCD, {
  //   fetchPolicy: 'cache-and-network',
  //   variables: {
  //     input: {
  //       productCode: 'All',
  //       domainType: 'Permit Type MISCD',
  //     },
  //   },
  //   onCompleted: (data) => {},
  // });
  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.toLowerCase() ===
        searchText?.toString()?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toString()?.toLowerCase() ===
            searchText?.toString()?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const modalSize = useResponsiveParams({
    for_mobile: 'full',
    for_desktop: 'large',
    for_iPad: 'full',
  });
  // if (loadingCarriageType || loadingPermitType) {

  //   return (
  //     <div className="min-h-screen">
  //       <Loading />
  //     </div>
  //   );
  // }
  // if (errorCarriageType || errorPermitType) {
  //   return <Error error={'Error'} />;
  // }
  const mapDataCarriageType=dataCarriageType?.getDomainData;
  // const mapDataPermitype = dataPermitType?.getDomainData;
  const mapVehicleusetype=datavehicleuseType?.getDomainData;
  const mapSubProducttype=dataSubProductType?.getDomainData;
  const mapTypeOfMiscVehicletype =
    dataTypeOfMiscVehicleType?.getDomainData;

  const validate = (values) => {
    // console.log("values in validate",values)
    const errors = {};
     if(!values?.vehicleuse?.value){
      errors.vehicleuse = {};
      errors.vehicleuse.value = '* Required';
    }
    // if(!values?.vehiclesubType?.value){
    //   errors.vehiclesubType= {};
    //   errors.vehiclesubType.value = '* Required';
    // }
    if (!values?.make?.value) {
      errors.make = {};
      errors.make.value = '* Required';
    }
    if (!values?.model?.value) {
      errors.model = {};
      errors.model.value = '* Required';
    }
    if (!values?.variant?.value) {
      errors.variant = {};
      errors.variant.value = '* Required';
    }
 
    if (!values?.rtoLocationCode) {
      errors.rtoLocationCode = '* Required';
    }
    if (!values?.yearOfManufacture) {
      errors.yearOfManufacture = '* Required';
    }
    if (!values?.dateOfReg) {
      errors.dateOfReg = '* Required';
    }
    if (values?.dateOfReg) {
      if (moment(values?.dateOfReg, 'DD/MM/YYYY').isAfter()) {
        errors.dateOfReg =
          '* Date of Registration cannot be future date';
      }
      else if ((businessType === 'New Business') &&
        moment(values?.dateOfReg, 'DD/MM/YYYY').isBefore() &&
        moment(new Date(), 'DD/MM/YYYY').diff(
          moment(values?.dateOfReg, 'DD/MM/YYYY'), 'days') > 275) {
        errors.dateOfReg = '*Date of Registration/Purchase can be taken backdated only upto 275 days';
      }
    }
      if (
      values?.dateOfReg &&
        values?.yearOfManufacture &&
      parseInt(moment(values?.dateOfReg, 'DD/MM/YYYY')?.get('year')) <
        parseInt(values?.yearOfManufacture)
      ) {
      errors.dateOfReg =
        "* Registration/Purchase date can't be less than date of manufacture";
    }
    if (
      values?.make?.value &&
      getDomainData(
        makeList,
        values?.make?.value,
        'value',
        'code',
      ) === ''
    ) {
      errors.make = { value: '* Invalid make' };
    }
    if (
      values?.model?.value &&
      getDomainData(
        values?.modelList,
        values?.model?.value,
        'value',
        'code',
      ) === ''
    ) {
      errors.model = { value: '* Invalid model' };
    }
    if (
      values?.variant?.value &&
      !values?.variantList
        ?.filter((variant) => variant?.variantName && variant?.fuel)
        ?.find(
          (variant) =>
            `${variant?.variantName} # ${variant?.fuel} # ${variant?.cubeCapacity}`
              ?.toString()
              ?.toLowerCase() ===
            values?.variant?.value?.toString()?.toLowerCase(),
        )
    ) {
      errors.variant = { value: '* Invalid variant' };
    }
    if (!values?.rtoAuthAndLocationDesc) {
      errors.rtoAuthAndLocationDesc = '* Required';
    }
    // console.log("erorors",errors)
    if (values?.rtoAuthAndLocationDesc?.lastIndexOf('-') > 4) {
      var temp = values?.rtoAuthAndLocationDesc?.substr(5);
    if (
      values?.rtoAuthAndLocationDesc &&
      (getDomainData(
        rtoList,
        values?.rtoAuthAndLocationDesc?.split('-')[0],
        'rtoAuthCode',
        'rtoAuthCode',
      ) === '' ||
        getDomainData(
            rtoList,
            temp,
            'rtoLocDesc',
            'rtoLocDesc',
          ) === '')
      ) {
        errors.rtoAuthAndLocationDesc = '* Invalid RTO';
      }
    } else {
      let rtoLst = values?.rtoList?.length > 0 
      ? values?.rtoList 
      : rtoList ;
      if (
        values?.rtoAuthAndLocationDesc &&
        (getDomainData(
          rtoLst,
          values?.rtoAuthAndLocationDesc?.split('-')[0],
          'rtoAuthCode',
          'rtoAuthCode',
        ) === '' ||
          getDomainData(
            rtoLst,
          values?.rtoAuthAndLocationDesc?.split('-')[1],
          'rtoLocDesc',
          'rtoLocDesc',
        ) === '')
    ) {
      errors.rtoAuthAndLocationDesc = '* Invalid RTO';
      }
    }
    return errors;
  };

  const SelectVehicalDetails = ({ validate }) => {
    const [errorModelData, setErrorModelData] = useState(null);
    const [loadingModelData, setLoadingModelData] = useState(false);
    const [loadingVariantData, setLoadingVariantData] =
      useState(false);
    const [errorVariantData, setErrorVariantData] = useState(null);
    const [errortypesearchData, settypesearcherrorData] = useState(null);
    // const [ vehicleTypeList, setVehicleTypeList] =useState([]);
    const [loadingtypesearchData, setLoadingtypeData] =
    useState(false);
    const [loadingRto, setLoadingRto] = useState(false);
    const { values, setFieldValue, submitForm, resetForm } =
      useQuantaFormikContext();
    const RTOSearch = async (val) => {
      if (val?.toString()?.length > 0) {
        try {
          setFieldValue('rtoList', []);
          const rtoSearchquery = fetchQuery({
            query: GET_RTO_DETAILS,
            variables: {
              input: {
                rtoCode: val?.toString(),
                productCode: '3128',

              },
            },
          });
          setLoadingRto(true);
          const { data } = await rtoSearchquery;
          setLoadingRto(false);
          setRtoList(data?.RTODtlsSearch?.rto);
          setFieldValue('rtoList', data?.RTODtlsSearch?.rto);
          const rtoInfo = data?.RTODtlsSearch?.rto?.find(
            (rtoInfo) =>
              rtoInfo?.rtoAuthCode?.toLowerCase() ===
              val?.toLowerCase(),
          );
          if(rtoInfo){
            setFieldValue(
              `rtoLocationCode`,
              rtoInfo?.rtoLocCode
                ? rtoInfo?.rtoLocCode
                : '',
            );
            setFieldValue(
              `rtoAuthorityCode`,
              rtoInfo?.rtoAuthCode
                ? rtoInfo?.rtoAuthCode
                : '',
            );
            setFieldValue(
              `rtoLocationDesc`,
              rtoInfo?.rtoLocDesc
                ? rtoInfo?.rtoLocDesc
                : '',
            );
            setFieldValue(
              `rtoAuthAndLocationDesc`,
              `${rtoInfo?.rtoAuthCode}-${
                rtoInfo?.rtoLocDesc }`?.trim(),
            );
            vehicleDtls.current = {
              ...vehicleDtls.current,
              rtoList: data?.RTODtlsSearch?.rto,
              rtoLocationCode: rtoInfo?.rtoLocCode,
              rtoLocationDesc: rtoInfo?.rtoLocDesc,
              rtoAuthorityCode: rtoInfo?.rtoAuthCode,
              rtoAuthAndLocationDesc:`${rtoInfo?.rtoAuthCode}-${
                rtoInfo?.rtoLocDesc }`?.trim()
            };
          }
        } catch (error) {
          setLoadingRto(false);
        }
      }
    };
    const onBrandSelected = async (val) => {
      if (val?.toString()?.length > 0) {
        try {
          setFieldValue('modelList', []);
          setErrorModelData(null);
          const vehicleModelquery = fetchQuery({
            query: MODEL_DETAILS,
            variables: {
              filter: {
              productCode,
              makeCode: val?.split('#')?.[1] 
              || getDomainData(
                makeList,
                val?.toString(),
                'value',
                'code',
              ),
              vehiclesubclasscode:
              values?.vehicleuse?.value.toString()?.search('Tractors') !==-1
              ? '69'
              : values?.vehicleuse?.value.toString()
                  ?.search('Miscellaneous') !==-1
              ? '70'
              : '',
              },
            },
          });
          setLoadingModelData(true);
          const { data } = await vehicleModelquery;
          setLoadingModelData(false);
          setFieldValue('modelList', data?.modelList);
          vehicleDtls.current = {
            ...vehicleDtls.current,
            modelList:data?.modelList,
          }
          if (data?.modelList?.length === 0) {
            setErrorModelData('Cannot find model details');
          } else {
            setErrorModelData(null);
          }
        } catch (error) {
          setLoadingModelData(false);
          setErrorModelData(error?.message);
        }
      }
    };
  const onVehicleUseSelected = async (val) => {
    if (val?.toString()?.length > 0) {
      try {
        //setFieldValue('typeOfMiscVehicle', []);
      settypesearcherrorData(null);
      const vehicletypesearchquery = fetchQuery({
        query: GET_TYPEVEHICLE_MISCD,
        variables: {
          input: {
            vehicleClassCode: 
                  val?.toString()?.search('Tractors') !==-1
                  // 'Tractors - Up to 6 HP'
            ? '69'
                    : val?.toString()?.search('Miscellaneous') !== -1
                      // 'Miscellaneous and special types'
            ? '70'
            :'',
            startDate:moment(new Date(), 'DD/MM/YYYY')?.format('DD/MM/YYYY'),
          },
        },
      });
        setLoadingtypeData(true);
        const { data } = await vehicletypesearchquery;
        setLoadingtypeData(false);
        // setFieldValue('typeOfMiscVehicle', data?.value);
       setVehicleTypeList(data?.typeVehicleSearchMISCD)
        if (data?.value?.length === 0) {
          settypesearcherrorData('Cannot find  details');
        } else {
          settypesearcherrorData(null);
        }
      } catch (error) {
        settypesearcherrorData(error?.message);
        setLoadingtypeData(false);
      }
    }
  };
    const onModelSelected = async (val) => {
      if (val?.toString()?.length > 0) {
        try {
          setFieldValue('variantList', []);
          setErrorVariantData(null);
          const vehicleVariantquery = fetchQuery({
            query: VARIANT_DETAILS,
            variables: {
              filter: {
              productCode,
              makeCode: values?.make?.code,
              modelCode: val?.split('#')?.[1],
              vehiclesubclasscode:
              values?.vehicleuse?.value.toString()?.search('Tractors') !==-1
              ? '69'
              : values?.vehicleuse?.value.toString()
                  ?.search('Miscellaneous') !==-1
              ? '70'
              : '',
                /* solution for multiple model with same name */
              // getDomainData(
              //     values?.modelList,
              //   val?.toString(),
              //   'value',
              //   'code',
              // ),
              },
            },
          });
          setLoadingVariantData(true);
          const { data } = await vehicleVariantquery;
          setLoadingVariantData(false);
          setFieldValue('variantList', data?.variantList);
          vehicleDtls.current = {
            ...vehicleDtls.current,
            variantList:data?.variantList,
          }
          if (data?.variantList?.length === 0) {
            setErrorVariantData('Cannot find variant details');
          } else {
            setErrorVariantData(null);
          }
        } catch (error) {
          setErrorVariantData(error?.message);
          setLoadingVariantData(false);
        }
      }
    };

    useEffect(()=>{
      if(vehicleRegNo?.length === 4 && rtoList?.length === 0){
        RTOSearch(vehicleRegNo?.slice(0, 4));
      }
    },[vehicleRegNo]);

    const data = [
      {
        grid_data: [
          {
            type:'select',
           //  colSpan:repeat,
            label: (
             <>
               Vehicle Use<Text severity="error"> *</Text>
             </>
           ),
           name: 'vehicleuse.value',
           // disabled: values?.quotationNo !== '',
           data: mapVehicleusetype &&
           mapVehicleusetype?.length > 0
             ? [...mapVehicleusetype?.map((val) => {
               return {
                 label: val?.value
                   ? `${val.value}`
                   : '',
                 value: val?.code
                   ? `${val.code}`
                   : '',
               }
             }),
             ]
             : [],
            onDataChange: (val, setFieldValue) => {
              if (val?.toLowerCase()?.search('private') !== -1) {
                setFieldValue('carriageType.code', 'Private');
                setFieldValue('carriageType.value', 'Private');
                vehicleDtls.current = {
                  ...vehicleDtls.current,
                  carriageType : {
                    code: 'Private',
                    value:'Private',
                  },
                } 
              }
              if (val?.toLowerCase()?.search('public') !== -1) {
                setFieldValue('carriageType.code', 'Public');
                setFieldValue('carriageType.value', 'Public');
                vehicleDtls.current = {
                  ...vehicleDtls.current,
                  carriageType : {
                    code: 'Public',
                    value:'Public',
                  },
                }
              }
              vehicleDtls.current = {
                ...vehicleDtls.current,
                vehicleuse: {
                  code: val?.toString(),
                  value: val?.toString(),
                },
              } 
              onVehicleUseSelected(val);
            },   
            },
           {
            type:'select',
           //  colSpan:repeat,
            label: (
             <>
               Sub Product<Text severity="error"> *</Text>
             </>
           ),
           name: 'subProduct.value',
           // disabled: values?.quotationNo !== '',
           data:mapSubProducttype &&
           mapSubProducttype?.length > 0
             ? [...mapSubProducttype?.map((val) => {
               return {
                 label: val?.value
                   ? `${val.value}`
                   : '',
                 value: val?.code
                   ? `${val.code}`
                   : '',
               }
             }),
             ]
             : [],
             onDataChange: (val, setFieldValue) => {
              vehicleDtls.current = {
                ...vehicleDtls.current,
                subProduct: {
                  code: getDomainData(
                    mapSubProducttype,
                    val?.toString(),
                    'value',
                    'code',
                  ),
                  value: val?.toString(),
                },
              }
            }
          },
          {
            type: 'select',
            //  colSpan:repeat,
            label: (
              <>
                Type of Miscd vehicle<Text severity="error"> *</Text>
              </>
            ),
            name: 'typeOfMiscVehicle.value',
            // disabled: values?.quotationNo !== '',
            data:
              // mapTypeOfMiscVehicletype &&
              // mapTypeOfMiscVehicletype?.length > 0
              //   ? [
              //       ...mapTypeOfMiscVehicletype?.map((val) => {
              //         return {
              //           label: val?.value ? `${val.value}` : '',
              //           value: val?.code ? `${val.code}` : '',
              //         };
              //       }),
              //     ]
                vehicleTypeList && 
                vehicleTypeList?.length > 0 ?
                vehicleTypeList.map((val) => {
                  if(productVariant?.toLowerCase()?.search('liability')!==-1)
                  {
                    if(val.value?.includes('AGRICULTURAL'))
                  return {
                    label: val?.value ? `${val.value}` : '',
                    value: val?.code ? `${val.code}` : '',
                  }
                }
                 else{
                  return {
                    label: val?.value ? `${val.value}` : '',
                    value: val?.code ? `${val.code}` : '',
                  }
                 }
                }).filter((d) => d)
                : [],
            onDataChange:async (val, setFieldValue) => {
                if (val?.toLowerCase()?.search('private') !== -1) {
                  setFieldValue('carriageType.code', 'Private');
                  setFieldValue('carriageType.value', 'Private');
                  vehicleDtls.current = {
                    ...vehicleDtls.current,
                    carriageType : {
                      code: 'Public',
                      value:'Public',
                    },
                  }
                }
                if (val?.toLowerCase()?.search('public') !== -1) {
                  setFieldValue('carriageType.code', 'Public');
                  setFieldValue('carriageType.value', 'Public')
                  vehicleDtls.current = {
                    ...vehicleDtls.current,
                    carriageType : {
                      code: 'Public',
                      value:'Public',
                    },
                  }
                }
                vehicleDtls.current = {
                  ...vehicleDtls.current,
                  typeOfMiscVehicle: {
                    code: getDomainData(
                      vehicleTypeList,
                      val?.toString(),
                      'value',
                      'code',
                    ),
                    value: val?.toString(),
                  },
                }
              }
           },
          {
            type: 'render',
            colSpan: repeat,
            component: () => (
              <div className="flex flex-col space-y-2 w-full">
                <Text className="font-bold px-3">Make</Text>
                {repeat === repeatForDesktop && (
                  <Text className="text-neutral-darker px-3">
                    Select from the popular brands
                  </Text>
                )}
                <Grid
                  flow="cols"
                  repeat={repeat}
                  gap={4}
                  className="w-full"
                >
                  {repeat !== repeatForMobile &&
                    makeList?.slice(0, 9)?.map((v, idx) => {
                      return (
                        <GridItem
                          key={idx}
                          colSpan={1}
                          className="px-3"
                        >
                          <Button
                            type={'button'}
                            size="full"
                            flat={
                              values?.make?.code === v?.code
                                ? false
                                : true
                            }
                            className="w-44"
                            onClick={async (_) => {
                              setFieldValue('make.code', v.code);
                              setFieldValue('make.value', v.value);
                              await onBrandSelected(v?.value);
                              setFieldValue('model.code', '');
                              setFieldValue('model.value', '');
                              setFieldValue('variant.code', '');
                              setFieldValue('variant.value', '');
                              vehicleDtls.current = {
                                ...vehicleDtls.current,
                                make: {
                                  code: v.code,
                                  value:v.value,
                                },
                              }  
                            }}
                          >
                            {v?.value}
                          </Button>
                        </GridItem>
                      );
                    })}
                  <GridItem colSpan={repeat} className="px-3">
                    <Label
                      text={
                        <Text type="label">
                          Select other brands{' '}
                          <Text severity="error">*</Text>
                        </Text>
                      }
                    >
                      <QuantaSelect
                        size="full"
                        name="make.value"
                        searchable={true}
                        colSpan={repeat}
                        data={makeList?.map((v) => {
                          return {
                            label: `${v?.value}#${v?.code}`
                              ? `${v?.value}#${v?.code}`
                              : '',
                            value: `${v?.value}#${v?.code}`
                              ? `${v?.value}#${v?.code}`
                              : '',
                          };
                        })}
                        onDataChange={async (val, setFieldValue) => {
                          await onBrandSelected(val);
                          setFieldValue(
                            'make.code',
                            val?.split('#')?.[1], 
                          );
                          setFieldValue(
                            'make.value',
                            val?.split('#')?.[0],
                          );
                          vehicleDtls.current = {
                            ...vehicleDtls.current,
                            make: {
                              code: val?.split('#')?.[1],
                              value: val?.split('#')?.[0],
                            },
                          }  
                          setFieldValue('model.code', '');
                          setFieldValue('model.value', '');
                          setFieldValue('variant.code', '');
                          setFieldValue('variant.value', '');
                          // setFieldValue(
                          //   `carriageType`,mapDataCarriageType[0].value)
                          //   setFieldValue(
                          //   `permitType`,mapDataPermitype[0].value)
                        }}
                      />
                    </Label>
                  </GridItem>
                </Grid>
              </div>
            ),
          },
          loadingModelData || errorModelData
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return loadingModelData ? (
                    <Loading
                      customMessage={
                        repeat === repeatForDesktop ? (
                          `Fetching Vehicle Models`
                        ) : (
                          <Text severity="info" type="normal">
                            Fetching Vehicle Models
                          </Text>
                        )
                      }
                    />
                  ) : (
                    <Text
                      severity="error"
                      type="normal"
                      className="flex items-center justify-center space-x-2"
                    >
                      <Text severity="error" type="normal">
                        <FontAwesomeIcon icon={faExclamationCircle} />
                      </Text>
                      <Text severity="error" type="normal">
                        {errorModelData}
                      </Text>
                    </Text>
                  );
                },
              }
            : values?.make?.code &&
              makeList?.find(
                (make) =>
                  make?.code?.toString()?.toLowerCase() ===
                  values?.make?.code?.toString()?.toLowerCase(),
              ) &&
              !loadingModelData &&
              values?.make?.code &&
              makeList?.find(
                (make) =>
                  make?.code?.toString()?.toLowerCase() ===
                  values?.make?.code?.toString()?.toLowerCase(),
              )
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => (
                  <div className="flex flex-col space-y-2 w-full">
                    <Text className="font-bold px-3">Model</Text>
                    <Grid
                      flow="cols"
                      repeat={repeat}
                      gap={4}
                      className="w-full"
                    >
                      {/* {makeList?.find(
                          (make) =>
                            make?.code?.toString()?.toLowerCase() ===
                            values?.make?.toString()?.toLowerCase(),
                        )
                          ? modelList?.slice(0, 6)?.map((v, idx) => {
                              return (
                                <GridItem key={idx} colSpan={1}>
                                  <Button
                                    type={'button'}
                                    size="full"
                                    flat={
                                      values?.model === v?.code
                                        ? false
                                        : true
                                    }
                                    className="w-40"
                                    onClick={async (_) => {
                                      setFieldValue('model', v.code);
                                      await onModelSelected(v?.code);
                                      setFieldValue('variant', '');
                                    }}
                                  >
                                    {v?.value}
                                  </Button>
                                </GridItem>
                              );
                            })
                          : null} */}
                      <GridItem colSpan={repeat} className="px-3">
                        <Label
                          text={
                            <Text type="label">
                              Select the Appropriate Model from the
                              list <Text severity="error">*</Text>
                            </Text>
                          }
                        >
                          <QuantaSelect
                            size="full"
                            name="model.value"
                            placeholder={'Select a model'}
                            searchable={true}
                            colSpan={repeat}
                            data={
                              makeList && makeList?.length > 0
                                ? makeList?.find(
                                    (make) =>
                                      make?.code
                                        ?.toString()
                                        ?.toLowerCase() ===
                                      values?.make?.code
                                        ?.toString()
                                        ?.toLowerCase(),
                                  )
                                  ? values?.modelList?.map((v) => {
                                      /* SU solution for multiple model with same name */
                                      return {
                                        label: `${v?.value}#${v?.code}`  
                                          ? `${v?.value}#${v?.code}`
                                          : '',
                                        value: `${v?.value}#${v?.code}`
                                          ? `${v?.value}#${v?.code}`
                                          : '',
                                      };
                                    /* EU solution for multiple model with same name */
                                    })
                                  : []
                                : []
                            }
                            onDataChange={async (
                              val,
                              setFieldValue,
                            ) => {
                              await onModelSelected(val);
                             /* SU solution for multiple model with same name */
                              setFieldValue(
                                'model.code',
                              val?.split('#')?.[1], 
                              // getDomainData(
                              //   values?.modelList,
                              //   val?.toString(),
                              //   'value',
                              //   'code',
                              // ),
                              );
                            setFieldValue(
                              'model.value',
                              val?.split('#')?.[0],
                            );
                            /* EU solution for multiple model with same name */
                            vehicleDtls.current = {
                              ...vehicleDtls.current,
                              model: {
                                code: val?.split('#')?.[1],
                                value:val?.split('#')?.[0],
                              },
                            }
                              setFieldValue('variant.code', '');
                              setFieldValue('variant.value', '');
                            }}
                          />
                        </Label>
                      </GridItem>
                    </Grid>
                  </div>
                ),
              }
            : null,
          loadingVariantData || errorVariantData
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return loadingVariantData ? (
                    <Loading
                      customMessage={
                        repeat === repeatForDesktop ? (
                          `Fetching Vehicle Variants & Fuel Types`
                        ) : (
                          <Text severity="info" type="normal">
                            Fetching Vehicle Variants {'&'} Fuel Types
                          </Text>
                        )
                      }
                    />
                  ) : (
                    <Text
                      severity="error"
                      type="normal"
                      className="flex items-center justify-center space-x-2"
                    >
                      <Text severity="error" type="normal">
                        <FontAwesomeIcon icon={faExclamationCircle} />
                      </Text>
                      <Text severity="error" type="normal">
                        {errorVariantData}
                      </Text>
                    </Text>
                  );
                },
              }
            : values?.make?.code &&
              values?.model?.code &&
              makeList?.find(
                (make) =>
                  make?.code?.toString()?.toLowerCase() ===
                  values?.make?.code?.toString()?.toLowerCase(),
              ) &&
              !loadingVariantData &&
              values?.make?.code &&
              values?.model?.code &&
              makeList?.find(
                (make) =>
                  make?.code?.toString()?.toLowerCase() ===
                  values?.make?.code?.toString()?.toLowerCase(),
              ) &&
              values?.modelList?.find(
                (models) =>
                  models.code?.toString()?.toLowerCase() ===
                  values?.model?.code?.toString()?.toLowerCase(),
              )
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => (
                  <div className="flex flex-col space-y-2 w-full">
                    <Text className="font-bold px-3">
                      Variant & Fuel Type
                    </Text>
                    <Grid
                      flow="cols"
                      repeat={repeat}
                      gap={4}
                      className="w-full"
                    >
                      {/* {makeList?.find(
                            (make) =>
                              make?.code
                                ?.toString()
                                ?.toLowerCase() ===
                              values?.make?.toString()?.toLowerCase(),
                          )
                            ? modelList?.find(
                                (m) =>
                                  m?.code
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  values?.model
                                    ?.toString()
                                    ?.toLowerCase(),
                              )
                              ? variantList?.map((v, idx) => {
                                  return (
                                    <GridItem
                                      colSpan={1}
                                      key={idx}
                                    >
                                      <Button
                                        type={'button'}
                                        size="full"
                                        flat={true}
                                        className="w-40"
                                        onClick={(_) => {
                                          setFieldValue(
                                            'variant',
                                            v?.variantCode,
                                          );
                                          setFieldValue(
                                            `fuelType`,
                                            variantList?.find(
                                              (vl) =>
                                                vl?.variantCode?.toLowerCase() ===
                                                v?.variantCode?.toLowerCase(),
                                            )?.fuel,
                                          );
                                          setFieldValue(
                                            `seatingCapacity`,
                                            variantList?.find(
                                              (vl) =>
                                                vl?.variantCode?.toLowerCase() ===
                                                v?.variantCode?.toLowerCase(),
                                            )?.seatingCapacity,
                                          );
                                          setFieldValue(
                                            `cubeCapacity`,
                                            variantList?.find(
                                              (vl) =>
                                                vl?.variantCode?.toLowerCase() ===
                                                v?.variantCode?.toLowerCase(),
                                            )?.cubeCapacity,
                                          );
                                        }}
                                      >
                                        {v?.variantName}
                                      </Button>
                                    </GridItem>
                                  );
                                })
                              : null
                            : null} */}
                      <GridItem colSpan={repeat} className="px-3">
                        <Label
                          text={
                            <Text type="label">
                              Select the Appropriate Variant from the
                              list <Text severity="error">*</Text>
                            </Text>
                          }
                        >
                          <QuantaSelect
                            size={'full'}
                            name="variant.value"
                            searchable={true}
                            placeholder={'Search a variant'}
                            data={
                              makeList &&
                              makeList?.length > 0 &&
                              makeList?.find(
                                (make) =>
                                  make?.code
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  values?.make?.code
                                    ?.toString()
                                    ?.toLowerCase(),
                              ) &&
                              values?.modelList?.find(
                                (m) =>
                                  m?.code
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  values?.model?.code
                                    ?.toString()
                                    ?.toLowerCase(),
                              )
                                ? values?.variantList?.map((v) => {
                                    return {
                                      label:
                                        v?.variantName && v?.fuel
                                          ? `${v?.variantName} # ${v?.fuel} # ${v?.cubeCapacity}`
                                          : '',
                                      value:
                                        v?.variantName && v?.fuel
                                          ? `${v?.variantName} # ${v?.fuel} # ${v?.cubeCapacity}`
                                          : '',
                                    };
                                  })
                                : []
                            }
                            onDataChange={(val, setFieldValue) => {
                              setFieldValue(
                                `variant.code`,
                                getDomainData(
                                  values?.variantList,
                                  val
                                    ?.toString()
                                    ?.split('#')[0]
                                    ?.trim(),
                                  'variantName',
                                  'variantCode',
                                ),
                              );
                              setFieldValue(
                                `fuelType`,
                                values?.variantList?.find(
                                  (vl) =>
                                    vl?.variantName?.toLowerCase() ===
                                    val
                                      ?.toString()
                                      ?.split('#')[0]
                                      ?.trim()
                                      ?.toLowerCase(),
                                )?.fuel,
                              );
                              setFieldValue(
                                `seatingCapacity`,
                                values?.variantList?.find(
                                  (vl) =>
                                    vl?.variantName?.toLowerCase() ===
                                    val
                                      ?.toString()
                                      ?.split('#')[0]
                                      ?.trim()
                                      ?.toLowerCase(),
                                )?.seatingCapacity,
                              );
                              setFieldValue(
                                `carriageType.code`,values?.carriageType
                              );
                              setFieldValue(
                                `permitType.code`,
                               values?.permitType,
                              );
                              setFieldValue(
                                `gvw`,
                                values?.variantList?.find(
                                  (vl) =>
                                    vl?.variantName?.toLowerCase() ===
                                    val
                                      ?.toString()
                                      ?.split('#')[0]
                                      ?.trim()
                                      ?.toLowerCase(),
                                )?.gvw,
                              );
                              setFieldValue(
                                `carryingCapacity`,
                                values?.variantList?.find(
                                  (vl) =>
                                    vl?.variantName?.toLowerCase() ===
                                    val
                                      ?.toString()
                                      ?.split('#')[0]
                                      ?.trim()
                                      ?.toLowerCase(),
                                )?.carryingCapacity,
                              );
                              setFieldValue(
                                `cubeCapacity`,
                                values?.variantList?.find(
                                  (vl) =>
                                    vl?.variantName?.toLowerCase() ===
                                    val
                                      ?.toString()
                                      ?.split('#')[0]
                                      ?.trim()
                                      ?.toLowerCase(),
                                )?.cubeCapacity,
                              );
                              const variantDtls = values?.variantList?.find(
                                (vl) =>
                                  vl?.variantName?.trim()?.toLowerCase() ===
                                  val
                                    ?.toString()
                                    ?.split('#')[0]
                                    ?.trim()
                                    ?.toLowerCase(),
                              );
                              vehicleDtls.current = {
                                ...vehicleDtls.current,
                                variant: {
                                  code: variantDtls?.variantCode,
                                  value: val,
                                },
                                fuelType: variantDtls?.fuel,
                                seatingCapacity: variantDtls?.seatingCapacity,
                                cubeCapacity: variantDtls?.cubeCapacity,
                                carryingCapacity: variantDtls?.carryingCapacity,
                                gvw: variantDtls?.gvw,
                              }
                            }}
                          />
                        </Label>
                      </GridItem>
                    </Grid>
                  </div>
                ),
              }
            : null,
            loadingVariantData || errorVariantData
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return loadingVariantData ? (
                    <Loading
                      customMessage={
                        repeat === repeatForDesktop ? (
                          `Fetching Vehicle Variants & Fuel Types`
                        ) : (
                          <Text severity="info" type="normal">
                            Fetching Vehicle Variants {'&'} Fuel Types
                          </Text>
                        )
                      }
                    />
                  ) : (
                    <Text
                      severity="error"
                      type="normal"
                      className="flex items-center justify-center space-x-2"
                    >
                      <Text severity="error" type="normal">
                        <FontAwesomeIcon icon={faExclamationCircle} />
                      </Text>
                      <Text severity="error" type="normal">
                        {errorVariantData}
                      </Text>
                    </Text>
                  );
                },
              }
            /**  BT34369 :Hide vehicle subType
            : values?.make?.code &&
              values?.model?.code &&
              makeList?.find(
                (make) =>
                  make?.code?.toString()?.toLowerCase() ===
                  values?.make?.code?.toString()?.toLowerCase(),
              ) &&
              !loadingVariantData &&
              values?.make?.code &&
              values?.model?.code &&
              makeList?.find(
                (make) =>
                  make?.code?.toString()?.toLowerCase() ===
                  values?.make?.code?.toString()?.toLowerCase(),
              ) &&
              values?.modelList?.find(
                (models) =>
                  models.code?.toString()?.toLowerCase() ===
                  values?.model?.code?.toString()?.toLowerCase(),
              )
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => (
                  <div className="flex flex-col space-y-2 w-full">
                    <Text className="font-bold px-3">
                    Vehicle Sub Type
                    </Text>
                    <Grid
                      flow="cols"
                      repeat={repeat}
                      gap={4}
                      className="w-full"
                    >
                      <GridItem colSpan={repeat} className="px-3">
                        <Label
                          text={
                            <Text type="label">
                              Select the Appropriate Vehicle Sub Type from the
                              list <Text severity="error">*</Text>
                            </Text>
                          }
                        >
                          <QuantaSelect
                            size={'full'}
                            name="vehiclesubType.value"
                            searchable={true}
                            placeholder={'Search a VehicleSubtype'}
                            data={
                              makeList &&
                              makeList?.length > 0 &&
                              makeList?.find(
                                (make) =>
                                  make?.code
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  values?.make?.code
                                    ?.toString()
                                    ?.toLowerCase(),
                              ) &&
                              values?.modelList?.find(
                                (m) =>
                                  m?.code
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  values?.model?.code
                                    ?.toString()
                                    ?.toLowerCase(),
                              )
                                ? values?.variantList?.map((v) => {
                                
                                    return {
                                      label:
                                        v?.variantName 
                                          ? `${v?.variantName?.toString()
                                            ?.split('-')[1]
                                            ?.trim()}`
                                          : '',
                                      value:
                                        v?.variantName
                                          ? `${v?.variantName?.toString()
                                            ?.split('-')[1]
                                            ?.trim()}`
                                          : '',
                                    };
                                  })
                                : []
                            }
                            onDataChange = { (val, setFieldValue) => {
                                vehicleDtls.current = {
                                  ...vehicleDtls.current,
                                  vehiclesubType: {
                                    code: val?.toString(),
                                    value: val?.toString(),
                                  },
                                }
                              }
                            } 
                          />
                        </Label>
                      </GridItem>
                    </Grid>
                  </div>
                ),
              }   */
            : null,
          // {
          //   type: 'select',
          //   //  colSpan:repeat,
          //   label: (
          //     <>
          //       Carriage Type
          //     </>
          //   ),
          //   name: 'carriageType.code',
          //   // disabled: values?.quotationNo !== '',
          //   data:
          //     mapDataCarriageType && mapDataCarriageType?.length > 0
          //       ? [
          //           ...mapDataCarriageType?.map((val) => {
          //             return {
          //               label: val?.value ? `${val.value}` : '',
          //               value: val?.code ? `${val.code}` : '',
          //             };
          //           }),
          //         ]
          //       : [],
          // },
          // {
          //   type: 'select',
          //   //  colSpan:repeat,
          //   label: (
          //     <>
          //       Permit Type<Text severity="error"> </Text>
          //     </>
          //   ),
          //   name: 'permitType.code',
          //   // disabled: values?.quotationNo !== '',
          //   data:
          //     mapDataPermitype && mapDataPermitype?.length > 0
          //       ? [
          //           ...mapDataPermitype?.map((val) => {
          //             return {
          //               label: val?.value ? `${val.value}` : '',
          //               value: val?.code ? `${val.code}` : '',
          //             };
          //           }),
          //         ]
          //       : [],
          // },
          {
            type: 'render',
            colSpan: repeat,
            component: () => (
              <Text type="title" className="w-full px-3">
                RTO
              </Text>
            ),
          },
          {
            type: 'render',
            colSpan: repeat === repeatForDesktop ? 1 : repeat,
            component: () => (
              <div className="flex flex-col space-y-2 w-full">
                <Grid
                  flow="cols"
                  repeat={repeat === repeatForDesktop ? 1 : repeat}
                  gap={4}
                  className="w-full"
                >
                  <GridItem
                    colSpan={repeat === repeatForDesktop ? 1 : repeat}
                    className="px-3"
                  >
                    <QuantaSelect
                      size={'full'}
                      label={
                        <Text type="label">
                          RTO
                          <Text severity="error"> *</Text>
                        </Text>
                      }
                      name={'rtoAuthAndLocationDesc'}
                      disabled={loadingRto}
                      className={'uppercase'}
                      searchable={true}
                      data={
                        rtoList
                          ? [
                              ...(rtoList?.filter((rto) =>
                                rto?.rtoAuthCode
                                  ?.toLowerCase()
                                  ?.startsWith(
                                    vehicleRegNo
                                      ?.slice(0, 4)
                                      ?.toLowerCase(),
                                  ),
                              )?.length > 0
                                ? rtoList
                                    ?.filter((rto) =>
                                      rto?.rtoAuthCode
                                        ?.toLowerCase()
                                        ?.startsWith(
                                          vehicleRegNo
                                            ?.slice(0, 4)
                                            ?.toLowerCase(),
                                        ),
                                    )
                                    ?.map((rto) => {
                                      return {
                                        label:
                                          rto.rtoAuthCode &&
                                          rto.rtoLocDesc
                                            ? `${rto.rtoAuthCode}-${rto.rtoLocDesc}`?.trim()
                                            : '',
                                        value:
                                          rto.rtoAuthCode &&
                                          rto.rtoLocDesc
                                            ? `${rto.rtoAuthCode}-${rto.rtoLocDesc}`?.trim()
                                            : '',
                                      };
                                    })
                                : rtoList?.map((rto) => {
                                    return {
                                      label:
                                        rto.rtoAuthCode &&
                                        rto.rtoLocDesc
                                          ? `${rto.rtoAuthCode}-${rto.rtoLocDesc}`?.trim()
                                          : '',
                                      value:
                                        rto.rtoAuthCode &&
                                        rto.rtoLocDesc
                                          ? `${rto.rtoAuthCode}-${rto.rtoLocDesc}`?.trim()
                                          : '',
                                    };
                                  })),
                            ]
                          : []
                      }
                      onDataChange={async (val, setFieldValue) => {
                        if(val?.length  === 4 ){
                          await RTOSearch(val?.toLowerCase()?.split('-')[0])
                        }
                        
                        const rtoInfo = values?.rtoList?.find(
                          (rtoInfo) =>
                            rtoInfo?.rtoLocDesc?.toLowerCase() ===
                            val?.toLowerCase()?.split('-')[1]  && 
                            rtoInfo?.rtoAuthCode?.toLowerCase() ===
                            val?.toLowerCase()?.split('-')[0],
                        );
                        if(rtoInfo && val?.length  > 4 ) {
                          setFieldValue(
                            'rtoAuthAndLocationDesc',
                            val?.toUpperCase(),
                          );
                          setFieldValue(
                            `rtoLocationCode`,
                            rtoInfo?.rtoLocCode
                              ? rtoInfo?.rtoLocCode
                              : '',
                          );
                          setFieldValue(
                            `rtoAuthorityCode`,
                            rtoInfo?.rtoAuthCode
                              ? rtoInfo?.rtoAuthCode
                              : '',
                          );
                          setFieldValue(
                            `rtoLocationDesc`,
                            rtoInfo?.rtoLocDesc
                              ? rtoInfo?.rtoLocDesc
                              : '',
                          );
                          vehicleDtls.current = {
                            ...vehicleDtls.current,
                            rtoLocationCode: rtoInfo?.rtoLocCode,
                            rtoLocationDesc: rtoInfo?.rtoLocDesc,
                            rtoAuthorityCode: rtoInfo?.rtoAuthCode,
                            rtoAuthAndLocationDesc:  rtoInfo 
                            ? `${rtoInfo.rtoAuthCode}-${rtoInfo.rtoLocDesc}`?.trim()
                            : val?.toUpperCase(),
                          }
                        }
                      }}
                    />
                  </GridItem>
                </Grid>
              </div>
            ),
          },
          {
            type: 'render',
            colSpan: repeat === repeatForDesktop ? 1 : repeat,
            component: () => (
              <div className="flex flex-col space-y-2 w-full">
                <Grid
                  flow="cols"
                  repeat={repeat === repeatForDesktop ? 1 : repeat}
                  gap={4}
                  className="w-full"
                >
                  <GridItem
                    colSpan={repeat === repeatForDesktop ? 1 : repeat}
                    className="px-3"
                  >
                    <QuantaDateInput
                      size={'full'}
                      label={
                        <Text type="label">
                          Date of Registration/Purchase{' '}
                          <Text severity="error"> *</Text>
                        </Text>
                      }
                      name={'dateOfReg'}
                      calendarPosition={'top'}
                      onDataChange={async (
                        val,
                        setFieldValue,
                      ) => {
                        setFieldValue('yearOfManufacture',moment(val, 'DD/MM/YYYY')?.get('year'));
                        vehicleDtls.current = {
                          ...vehicleDtls.current,
                          dateOfReg: val,
                          yearOfManufacture: moment(val, 'DD/MM/YYYY')?.get('year')
                        }
                      }}
                      scrollStopWhenCalendarOpen={false}
                    />
                  </GridItem>
                </Grid>
              </div>
            ),
          },
          {
            type: 'render',
            colSpan: repeat === repeatForDesktop ? 1 : repeat,
            component: () => (
              <div className="flex flex-col space-y-2 w-full">
                <Grid
                  flow="cols"
                  repeat={repeat === repeatForDesktop ? 1 : repeat}
                  gap={4}
                  className="w-full"
                >
                  <GridItem
                    colSpan={repeat === repeatForDesktop ? 1 : repeat}
                    className="px-3"
                  >
                    <QuantaSelect
                      size={'full'}
                      label={
                        <Text type="label">
                          Year of Manufacture{' '}
                          <Text severity="error">*</Text>
                        </Text>
                      }
                      name={'yearOfManufacture'}
                      searchable={false}
                      data={Array.from(
                        {
                          length:
                            parseInt(yearRange?.maxYr) -
                            parseInt(yearRange?.minYr) +
                            1,
                        },
                        (_, i) => i + parseInt(yearRange?.minYr),
                      )?.map((year) => {
                        return {
                          label: `${year}`,
                          value: `${year}`,
                        };
                      })}
                      onDataChange={async (
                        val,
                        setFieldValue,
                      ) => {
                          vehicleDtls.current = {
                            ...vehicleDtls.current,
                            yearOfManufacture: val,
                          }
                      }}
                    />
                  </GridItem>
                </Grid>
              </div>
            ),
          },
        ].filter((d) => d),
      },
    ];

    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
    };

    return (
      <div className="flex flex-col md:justify-between pb-12">
        {/* <QuantaForm> */}
        <MixedGridGroup {...{ data, ...other_props }} />
        <div className="flex flex-row justify-end space-x-4 p-3">
          <span>
            <Button
              flat={true}
              type="button"
              size="small"
              className="w-32 h-10"
              onClick={(_) => {
                setShowVehicleDetailsModal(false);
                resetForm();
                document.body.classList.remove('overflow-y-hidden');
              }}
              iconPre={
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  className="ml-4"
                />
              }
              disabled={
                loadingVariantData ||
                loadingRtoDetails ||
                loadingModelData
              }
            >
              <span className="pl-1 text-base">Cancel</span>
            </Button>
          </span>
          <span>
            <Button
              flat={false}
              type="button"
              size="small"
              className="w-32 h-10"
              onClick={(_) => {
                setShowVehicleDetailsModal(false);
                submitForm();
                document.body.classList.remove('overflow-y-hidden');
              }}
              iconPre={
                <FontAwesomeIcon icon={faSave} className="ml-4" />
              }
              disabled={Object.keys(validate(values))?.length > 0}
            >
              <span className="pl-1 text-base">Save</span>
            </Button>
          </span>
        </div>
        {/* </QuantaForm> */}
      </div>
    );
  };

  const onSubmit = (values) => {
    let vechileDetails = {
      mode: 'manual',
      isRegNoVerified: null,
      make: values?.make,
      model: values?.model,
      variant: {
        variantCode: values?.variant?.code,
        variantName: values?.variant?.value?.split('#')[0]?.trim(),
      },
      fuelType: values?.fuelType,
      seatingCapacity: values?.seatingCapacity,
      cubeCapacity: values?.cubeCapacity,
      carryingCapacity:values?.carryingCapacity,
      gvw:values?.gvw,
      carriageType:{
      code:values?.carriageType?.code,
      value:values?.carriageType?.code
      },
      permitType:{
        code:values?.permitType?.code,
        value:values?.permitType?.code,
       },
       subProduct:{ code: values?.subProduct?.value,
        value: values?.subProduct?.value,},
       vehiclesubType:{
        code:values?.vehiclesubType?.value,
        value:values?.vehiclesubType?.value,
      },
      vehicleuse:{
        code:values?.vehicleuse?.value,
        value:values?.vehicleuse?.value,
       },
      typeOfMiscVehicle:{
       code:values?.typeOfMiscVehicle?.value,
       value:values?.typeOfMiscVehicle?.value,
      },
      yearOfManufacture: values?.yearOfManufacture,
      dateOfReg: values?.dateOfReg,
      rtoLocationCode: values?.rtoLocationCode,
      rtoLocationDesc: values?.rtoLocationDesc,
      rtoAuthorityCode: values?.rtoAuthorityCode,
      registrationNo: vehicleRegNo,
      engineNo,
      chasisNo,
    }
    setVehicleDetailValues(vechileDetails);
    if (vehicleDtls?.current?.mode?.toLowerCase() !== 'online') {
    setParentFieldValue(`isRegNoVerified`, null);
    setParentFieldValue(`mode`, 'manual');}
    else {
      setVehicleDetailValues({
        ...vechileDetails,
        financerName: vehicleDtls?.current?.financerName,
        prevInsurance: vehicleDtls?.current?.prevInsurance,
        mode: vehicleDtls?.current?.mode,
        isRegNoVerified: vehicleDtls?.current?.isRegNoVerified,
        isMakeDeclined: vehicleDtls?.current?.isDeclined,
      });
    }
  };

  const initialValues = {
    make: {
      code:   vehicleDtls?.current?.make?.code 
        ? vehicleDtls?.current?.make?.code 
        : '',
      value: vehicleDtls?.current?.make?.value 
        ? vehicleDtls?.current?.make?.value 
        : '',
    },
    model: {
      code: vehicleDtls?.current?.model?.code
        ? vehicleDtls?.current?.model?.code
        : '',
      value: vehicleDtls?.current?.model?.value
        ? vehicleDtls?.current?.model?.value
        : '',
    },
    modelList: vehicleDtls?.current?.modelList 
    ? vehicleDtls?.current?.modelList  
    : [],
    variant: {
      code: vehicleDtls?.current?.variant?.code
        ? vehicleDtls?.current?.variant?.code
        : '',
      value: vehicleDtls?.current?.variant?.value
        ? vehicleDtls?.current?.variant?.value
        : '',
    },
    carriageType: {
      code: vehicleDtls?.current?.carriageType?.code
        ? vehicleDtls?.current?.carriageType?.code
        : '',
      value: vehicleDtls?.current?.carriageType?.value
        ? vehicleDtls?.current?.carriageType?.value
        : '',
    },
    permitType:{
      code: '',
      value: '',
    },
    vehiclesubType: {
      code: vehicleDtls?.current?.vehiclesubType?.code
        ? vehicleDtls?.current?.vehiclesubType?.code
        : '',
      value: vehicleDtls?.current?.vehiclesubType?.value
        ? vehicleDtls?.current?.vehiclesubType?.value
        : '',
    },
    vehicleuse: {
      code: vehicleDtls?.current?.vehicleuse?.code
        ? vehicleDtls?.current?.vehicleuse?.code
        : '',
      value: vehicleDtls?.current?.vehicleuse?.value
        ? vehicleDtls?.current?.vehicleuse?.value
        : '',
    },
    subProduct: {
      code: vehicleDtls?.current?.subProduct?.code
        ? vehicleDtls?.current?.subProduct?.code
        : '',
      value: vehicleDtls?.current?.subProduct?.value
        ? vehicleDtls?.current?.subProduct?.value
        : '',
    },
    typeOfMiscVehicle: {
      code: vehicleDtls?.current?.typeOfMiscVehicle?.code
        ? vehicleDtls?.current?.typeOfMiscVehicle?.code
        : '',
      value: vehicleDtls?.current?.typeOfMiscVehicle?.value
        ? vehicleDtls?.current?.typeOfMiscVehicle?.value
        : '',
    },
    variantList: vehicleDtls?.current?.variantList
      ? vehicleDtls?.current?.variantList
      : [],
    rtoList: vehicleDtls?.current?.rtoList
      ? vehicleDtls?.current?.rtoList
      : [],
    rtoAuthAndLocationDesc: vehicleDtls?.current?.rtoAuthAndLocationDesc
      ? vehicleDtls?.current?.rtoAuthAndLocationDesc
      : rtoList?.filter((rto) =>
        rto?.rtoAuthCode
          ?.toLowerCase()
          ?.startsWith(vehicleRegNo?.slice(0, 4)?.toLowerCase()),
      )?.length === 1
        ? `${
            rtoList?.filter((rto) =>
              rto?.rtoAuthCode
                ?.toLowerCase()
                ?.startsWith(
                  vehicleRegNo?.slice(0, 4)?.toLowerCase(),
                ),
            )[0]?.rtoAuthCode
          }-${
            rtoList?.filter((rto) =>
              rto?.rtoAuthCode
                ?.toLowerCase()
                ?.startsWith(
                  vehicleRegNo?.slice(0, 4)?.toLowerCase(),
                ),
            )[0]?.rtoLocDesc
          }`
        : '',
    rtoLocationCode:vehicleDtls?.current?.rtoLocationCode
      ? vehicleDtls?.current?.rtoLocationCode
      :  rtoList?.filter((rto) =>
        rto?.rtoAuthCode
          ?.toLowerCase()
          ?.startsWith(vehicleRegNo?.slice(0, 4)?.toLowerCase()),
      )?.length === 1
        ? `${
            rtoList?.filter((rto) =>
              rto?.rtoAuthCode
                ?.toLowerCase()
                ?.startsWith(
                  vehicleRegNo?.slice(0, 4)?.toLowerCase(),
                ),
            )[0]?.rtoLocCode
          }`
        : '',
    rtoLocationDesc:  vehicleDtls?.current?.rtoLocationDesc
      ? vehicleDtls?.current?.rtoLocationDesc
      : rtoList?.filter((rto) =>
        rto?.rtoAuthCode
          ?.toLowerCase()
          ?.startsWith(vehicleRegNo?.slice(0, 4)?.toLowerCase()),
      )?.length === 1
        ? `${
            rtoList?.filter((rto) =>
              rto?.rtoAuthCode
                ?.toLowerCase()
                ?.startsWith(
                  vehicleRegNo?.slice(0, 4)?.toLowerCase(),
                ),
            )[0]?.rtoLocDesc
          }`
        : '',
    rtoAuthorityCode: vehicleDtls?.current?.rtoAuthorityCode
      ? vehicleDtls?.current?.rtoAuthorityCode
      : rtoList?.filter((rto) =>
        rto?.rtoAuthCode
          ?.toLowerCase()
          ?.startsWith(vehicleRegNo?.slice(0, 4)?.toLowerCase()),
      )?.length === 1
        ? `${
            rtoList?.filter((rto) =>
              rto?.rtoAuthCode
                ?.toLowerCase()
                ?.startsWith(
                  vehicleRegNo?.slice(0, 4)?.toLowerCase(),
                ),
            )[0]?.rtoAuthCode
          }`
        : '',
        
    // yearOfManufacture:moment(new Date(), 'DD/MM/YYYY') ? moment(val, 'DD/MM/YYYY')?.get('year') : '',
    yearOfManufacture:  vehicleDtls?.current?.yearOfManufacture
      ?  vehicleDtls?.current?.yearOfManufacture
      :   businessType === 'New Business' 
        ? moment(moment(new Date() ,'DD/MM/YYY')?.format('DD/MM/YYYY'), 'DD/MM/YYYY')?.get('year')
        : '', 
    dateOfReg: vehicleDtls?.current?.dateOfReg
      ? vehicleDtls?.current?.dateOfReg
      : businessType === 'New Business' 
        ? moment(new Date(), 'DD/MM/YYYY')?.format('DD/MM/YYYY') 
        : '',
    //  dateofReg: '',
    fuelType: vehicleDtls?.current?.fuelType
      ? vehicleDtls?.current?.fuelType
      : '',
    cubeCapacity: vehicleDtls?.current?.cubeCapacity
      ? vehicleDtls?.current?.cubeCapacity
      : '',
    seatingCapacity: vehicleDtls?.current?.seatingCapacity
      ? vehicleDtls?.current?.seatingCapacity
      : '',
    carryingCapacity: vehicleDtls?.current?.carryingCapacity
      ? vehicleDtls?.current?.carryingCapacity
      : '',
    gvw: vehicleDtls?.current?.gvw
      ? vehicleDtls?.current?.gvw
      : '',
  };
  return (
    <Modal
      display={showVehicleDetailsModal}
      size={modalSize}
      title={
        <Text severity="info" type="title" className="ml-3">
          Enter Your Vehicle details
        </Text>
      }
      // className="min-h-screen flex flex-col justify-start mt-30"
      className={repeat === repeatForMobile ? 'min-h-screen flex flex-col mt-16':''}
      severity="action"
      onClose={() => {
        setShowVehicleDetailsModal(false);
        vehicleModalRef?.current?.resetForm();
      }}
      modalCloseDisabled={loadingRtoDetails}
      restrictBackground={true}
    >
      {/* {(loadingYearRange || loadingBrands || loadingRTOList) && (
        <Loading
          customMessage={
            loadingYearRange
              ? 'Fetching Manufacture Year Information'
              : loadingBrands
              ? 'Fetching Brands'
              : loadingRTOList
              ? 'Fetching RTO Information'
              : undefined
          }
        />
      )}
      {(errorYearRange || errorRTOList) && (
        <Error error={errorYearRange || errorRTOList} />
      )}
      {!loadingYearRange &&
        !loadingBrands &&
        !loadingRTOList &&
        !errorYearRange &&
        !errorRTOList && ( */}
      {loadingRtoDetails && <Loading />}
      {errorRtoDetails && <Error error={errorRtoDetails} />}
      {!loadingRtoDetails && !errorRtoDetails && rtoList && (
        <QuantaFormik
          innerRef={vehicleModalRef}
          enableReinitialize={true}
          {...{ initialValues, onSubmit, validate }}
        >
          <SelectVehicalDetails {...{ validate }} />
        </QuantaFormik>
      )}
    </Modal>
  );
}
